import axios from "axios";
import { axiosInstance } from "../../../shared/axios";
const token = localStorage.getItem("obenev-token");

export const axiosInstanceForReferalURL = axios.create({
    baseURL: "https://apicw.obenev.obenelectric.com",
    headers: {
        Authorization: `Bearer ${token}`,
    },
});


export const getRedirects = async ({ page = 1, limit = 10 } = {}) => {
    try {
        const { data } = await axiosInstance.get(
            `/route-redirect?page=${page}&limit=${limit}`
        );
        return data?.data || [];
    } catch (e) {
        return { error: "Something went wrong while fetching redirects." };
    }
};

export const createRedirect = async (payload) => {
    try {
        const { data } = await axiosInstance.post(`/route-redirect`, payload);
        return data?.data || data;
    } catch (e) {
        return { error: "Something went wrong while creating the redirect." };
    }
};


export const updateRedirect = async (id, payload) => {
    try {
        const { data } = await axiosInstance.put(
            `/route-redirect/${id}`,
            payload
        );
        return data?.data || data;
    } catch (e) {
        return { error: "Something went wrong while updating the redirect." };
    }
};

export const deleteRedirect = async (id) => {
    try {
        const { data } = await axiosInstance.delete(`/route-redirect/${id}`);
        return data?.data || data;
    } catch (e) {
        return { error: "Something went wrong while deleting the redirect." };
    }
};

export const bulkCreateRedirects = async (items) => {
    try {
        const results = await Promise.all(
            items.map((item) => axiosInstance.post(`/route-redirect`, item))
        );
        return results.map((r) => r.data?.data || r.data);
    } catch (e) {
        return { error: "Something went wrong during bulk creation." };
    }
};

export const bulkUploadRedirectFile = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const { data } = await axiosInstance.post(`/route-redirect-bulk`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return data?.data || data;
    } catch (e) {
        return { error: e?.response?.data?.message || "Something went wrong during file upload." };
    }
};